import isCompositeImage from '../../common/helpers/is-composite-image';

const IMAGE_WIDGET_SELECTOR = 'ws-block[widget="image"]';
const VIDEO_WIDGET_SELECTOR = 'ws-block[widget="video"]';

const widgetsToSkip = [VIDEO_WIDGET_SELECTOR, IMAGE_WIDGET_SELECTOR];

const shouldSkipSameBoundsElement = (sourceElement, element) => {
  // Skip image widgets with composite images
  if (element.matches(widgetsToSkip) && isCompositeImage(sourceElement)) {
    return true;
  }

  return false;
};

export default shouldSkipSameBoundsElement;
